import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ThemeModeProvider } from "./Pages/context/ThemeModeContext";
import { LanguageProvider } from "./Pages/context/LanguageContext";

ReactDOM.render(
  <LanguageProvider>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </LanguageProvider>,
  document.getElementById("root")
);
